import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, PhoneIcon, MailIcon, MapPinIcon } from 'lucide-react';
import { Helmet } from 'react-helmet-async';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App({
  children
}: {
  children: React.ReactNode;
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navItems = [{
    name: 'Beranda',
    path: '/'
  }, {
    name: 'Tentang Kami',
    path: '/about'
  }, {
    name: 'Visi & Misi',
    path: '/vision-mission'
  }, {
    name: 'Layanan',
    path: '/services'
  }, {
    name: 'Bandara',
    path: '/airports'
  }, {
    name: 'Pimpinan',
    path: '/leadership'
  }, {
    name: 'Kontak',
    path: '/contact'
  }];
  const airports = [{
    name: 'Halim Perdanakusuma',
    code: 'HLP'
  }, {
    name: 'Bersujud',
    code: 'BTW'
  }, {
    name: 'Syamsudin Noor',
    code: 'BDJ'
  }, {
    name: 'Sultan Hasanuddin',
    code: 'UPG'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <div className="min-h-screen w-full bg-white" data-id="element-0">
      <Helmet data-id="element-1">
        <html lang="id" data-id="element-2" />
        <meta charSet="utf-8" data-id="element-3" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" data-id="element-4" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" data-id="element-5" />
        <meta name="theme-color" content="#0ea5e9" data-id="element-6" />
        <meta name="format-detection" content="telephone=yes" data-id="element-7" />
        <meta name="mobile-web-app-capable" content="yes" data-id="element-8" />
        <meta name="apple-mobile-web-app-capable" content="yes" data-id="element-9" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" data-id="element-10" />
        <link rel="canonical" href={`https://jagatindoperkasa.id${location.pathname}`} data-id="element-11" />
      </Helmet>
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
          <div className="flex justify-between items-center py-4" data-id="element-14">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2 sm:space-x-3" data-id="element-15">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center flex-shrink-0" data-id="element-16">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8jgZpKMjkbzQKHYEABy4NW/PT_JAGAT_INDO_PERKASA-1.png" alt="PT Jagat Indo Perkasa Logo - Ground Handling Indonesia" className="w-full h-full object-contain" width="48" height="48" data-id="element-17" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-18">
                <div className="text-gray-900 font-bold text-xs sm:text-lg leading-tight" data-id="element-19">
                  PT. JAGAT INDO PERKASA
                </div>
                <div className="text-sky-600 text-[10px] sm:text-xs leading-tight" data-id="element-20">
                  Ground Handling Excellence
                </div>
              </div>
            </Link>
            {/* Desktop Navigation */}
            <nav className="hidden lg:flex space-x-1" role="navigation" aria-label="Main navigation" data-id="element-21">
              {navItems.map(item => <Link key={item.path} to={item.path} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${isActive(item.path) ? 'bg-sky-500 text-white' : 'text-gray-700 hover:bg-sky-50 hover:text-sky-600'}`} aria-current={isActive(item.path) ? 'page' : undefined} data-id="element-22">
                  {item.name}
                </Link>)}
            </nav>
            {/* Mobile Menu Button */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden p-2 rounded-lg hover:bg-gray-100" aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileMenuOpen} data-id="element-23">
              {mobileMenuOpen ? <XIcon className="w-6 h-6 text-gray-700" data-id="element-24" /> : <MenuIcon className="w-6 h-6 text-gray-700" data-id="element-25" />}
            </button>
          </div>
          {/* Mobile Navigation */}
          {mobileMenuOpen && <nav className="lg:hidden pb-4 space-y-1" role="navigation" aria-label="Mobile navigation" data-id="element-26">
              {navItems.map(item => <Link key={item.path} to={item.path} onClick={() => setMobileMenuOpen(false)} className={`block px-4 py-2 rounded-lg text-sm font-medium transition-colors ${isActive(item.path) ? 'bg-sky-500 text-white' : 'text-gray-700 hover:bg-sky-50 hover:text-sky-600'}`} aria-current={isActive(item.path) ? 'page' : undefined} data-id="element-27">
                  {item.name}
                </Link>)}
            </nav>}
        </div>
      </header>
      {/* Main Content */}
      <main role="main" data-id="element-28">{children}</main>
      {/* WhatsApp Floating Button */}
      <WhatsAppButton data-id="element-29" />
      {/* Footer */}
      <footer className="bg-gray-900 text-white" role="contentinfo" data-id="element-30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-31">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-32">
            {/* Company Info */}
            <div data-id="element-33">
              <div className="mb-4" data-id="element-34">
                <div className="text-lg font-bold" data-id="element-35">PT. JAGAT INDO PERKASA</div>
              </div>
              <p className="text-gray-400 text-sm mb-4" data-id="element-36">
                Profesionalisme dan Dedikasi dalam Setiap Operasi Ground
                Handling
              </p>
              <div className="flex items-start space-x-2 text-gray-400 text-sm" data-id="element-37">
                <MapPinIcon className="w-4 h-4 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-38" />
                <address className="not-italic" data-id="element-39">
                  <div data-id="element-40">Bandara Halim Perdanakusuma</div>
                  <div data-id="element-41">Sisi Airside No. 77A</div>
                  <div data-id="element-42">Jakarta, Indonesia</div>
                </address>
              </div>
            </div>
            {/* Quick Links */}
            <div data-id="element-43">
              <h3 className="font-semibold mb-4" data-id="element-44">Link Cepat</h3>
              <ul className="space-y-2 text-sm" data-id="element-45">
                {navItems.map(item => <li key={item.path} data-id="element-46">
                    <Link to={item.path} className="text-gray-400 hover:text-sky-400 transition-colors" data-id="element-47">
                      {item.name}
                    </Link>
                  </li>)}
              </ul>
            </div>
            {/* Airports */}
            <div data-id="element-48">
              <h3 className="font-semibold mb-4" data-id="element-49">Bandara</h3>
              <ul className="space-y-2 text-sm" data-id="element-50">
                {airports.map(airport => <li key={airport.code} data-id="element-51">
                    <Link to="/airports" className="text-gray-400 hover:text-sky-400 transition-colors" data-id="element-52">
                      {airport.name} ({airport.code})
                    </Link>
                  </li>)}
              </ul>
            </div>
            {/* Contact Info */}
            <div data-id="element-53">
              <h3 className="font-semibold mb-4" data-id="element-54">Hubungi Kami</h3>
              <div className="space-y-3 text-sm" data-id="element-55">
                <div className="flex items-center space-x-3 text-gray-400" data-id="element-56">
                  <PhoneIcon className="w-4 h-4" aria-hidden="true" data-id="element-57" />
                  <a href="tel:+6281114477977" className="hover:text-sky-400 transition-colors" aria-label="Telepon PT Jagat Indo Perkasa" data-id="element-58">
                    +62 811-1477-977
                  </a>
                </div>
                <div className="flex items-center space-x-3 text-gray-400" data-id="element-59">
                  <MailIcon className="w-4 h-4" aria-hidden="true" data-id="element-60" />
                  <a href="mailto:jagatindoperkasa1977@gmail.com" className="hover:text-sky-400 transition-colors" aria-label="Email PT Jagat Indo Perkasa" data-id="element-61">
                    jagatindoperkasa1977@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400" data-id="element-62">
            <p data-id="element-63">© 2025 PT Jagat Indo Perkasa. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </div>;
}